import { Button, type ButtonProps, Link } from '@mui/material';

import { useMember } from 'modules/common/queries/member';
import { MemberStatus } from 'modules/common/interfaces/member';
import { MessageCenterScreen } from 'modules/common/components/Navigator/context/NavigatorContext.interface';
import useIMC from 'modules/IMC/useIMC';

interface MessageCenterLinkProps {
    color?: ButtonProps['color'];
}

export default function MessageCenterLink({ color = undefined }: MessageCenterLinkProps) {
    const { openMessageCenter } = useIMC();
    const { data: member } = useMember();
    const defaultColor = member?.status === MemberStatus.PAYMENT_ERROR ? 'red' : 'primary';

    return (
        <Button
            component={Link}
            variant="text"
            color={color || defaultColor}
            onClick={() => openMessageCenter(MessageCenterScreen.HOME)}
            sx={{
                typography: 'body1',
                p: 0,
                verticalAlign: 'text-bottom',
                minWidth: 'auto',
                textDecoration: 'underline',
                '&:hover': {
                    textDecoration: 'underline',
                },
            }}>
            Message Center
        </Button>
    );
}
